import React, { useEffect, useState } from "react";
import sideImage from "./Assets/sideInstituteImage.png";

const InstituteDataReview = ({setOpenSignupScreen, InstituteData, handleSubmit}) => {

return(
    <div className="w-full flex gap-[20px]  h-screen ">
        {/* <div className="w-[40%] h-screen hidden ">
                <img src={sideImage} alt="sideImage" className="w-full h-[140%] object-cover" />
        </div> */}

        <div className="w-full flex p-[30px] flex flex-col gap-[15px] lg:gap-[10px] mt-[10px] lg:mt-[20px] mb-[30px] pb-[50px]">
            {/* <p className="text-[22px] text-[#5F56A8] font-bold">Registration Data Review</p> */}
            <div className="w-full flex justify-between pb-[10px]"
                style={{
                        borderBottom:"2px dashed #A4A4A4"
                }}> 
                        <p className="text-[22px] text-[#1D1D1D] font-bold">Institute Data</p>

                        <button
                        className={`w-[80px] cursor-pointer rounded-[6px] border-none bg-primary py-1
                                text-[16px] text-white  xl:py-1
                                        xl:text-[18px]     2xl:text-base`}
                        onClick={()=>setOpenSignupScreen("PartnerRegisteration")}
                        >
                        Edit
                        </button>
            </div>
            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Email Address</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.email}</p>
            </div>

            <div className="w-full flex justify-between py-[10px] bg-[#F8F8F8]"
             style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="w-[80px] lg:w-full text-[18px] text-[#000000] font-bold">Website (if any)</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.website}</p>
            </div>

            <div className="w-full flex justify-between ">
                    <p className="text-[18px] text-[#000000] font-bold">Business Name</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.businessName}</p>
            </div>

            <div className="w-full flex justify-between py-[10px] bg-[#F8F8F8]"
              style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="text-[18px] text-[#000000] font-bold">Postal Code</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.postalCode}</p>
            </div>

            <div className="w-full flex justify-between ">
                    <p className="text-[18px] text-[#000000] font-bold">Country</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.country}</p>
            </div>

            <div className="w-full flex justify-between py-[10px] bg-[#F8F8F8]"
              style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="text-[18px] text-[#000000] font-bold">Province</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.province}</p>
            </div>

            <div className="w-full flex justify-between ">
                    <p className="text-[18px] text-[#000000] font-bold">City</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.city}</p>
            </div>

            <div className="w-full flex justify-between gap-[50px] py-[10px] bg-[#F8F8F8]"
              style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="text-[18px] text-[#000000] font-bold ">Address</p>
                    <p className="text-[18px] text-[#000000] ">{InstituteData?.partnerData?.Address}</p>
            </div>

            <div className="w-full flex justify-between "
             >
                    <p className="text-[18px] text-[#000000] font-bold">Institute Contact Number</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.contactNumber}</p>
            </div>

            <div className="w-full flex justify-between py-[10px] bg-[#F8F8F8]"
             style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="text-[18px] text-[#000000] font-bold">Emergency Contact Number</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.emergencyNumber}</p>
            </div>

            <div className="w-full flex justify-between pb-[10px]"
             style={{
                                borderBottom:"1px dashed #C9C9C9"
                        }}>
                    <p className="text-[18px] text-[#000000] font-bold">Emergency Email Address</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.partnerData?.emergencyEmail}</p>
            </div>

            <div className="w-full flex justify-between mt-[20px] py-[10px]"
                style={{
                                borderBlock:"2px dashed #A4A4A4"
                        }}>
                    <p className="text-[22px] text-[#000000] font-bold">Attachables (click on file name to view)</p>
            </div>

            <div className="w-full flex justify-between mt-[10px] py-[10px] bg-[#F8F8F8]"
            style={{
                        borderTop:"1px dashed #C9C9C9",
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                    <p className="text-[18px] text-[#000000] font-bold">Business Registration Certificate</p>
                    {InstituteData.partnerData.businessRegistration ? (
                        <a
                        href={InstituteData.partnerData.businessRegistration.previewURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#625BA8] underline text-[18px]"
                        >
                        {InstituteData.partnerData.businessRegistration.file.name}
                        </a>
                        ) : null}
            </div>

            <div className="w-full flex justify-between ">
                    <p className="text-[18px] text-[#000000] font-bold">Ministry of Transportation Registration</p>
                    {InstituteData.partnerData.transportationRegistration ? (
                        <a
                        href={InstituteData.partnerData.transportationRegistration.previewURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#625BA8] underline text-[18px]"
                        >
                        {InstituteData.partnerData.transportationRegistration.file.name}
                        </a>
                        ) : null}
            </div>

            {/* Institute Logo */}
                <div className="w-full flex justify-between  py-[10px] bg-[#F8F8F8]"
                style={{
                borderTop: "1px dashed #C9C9C9",
                borderBottom: "1px dashed #C9C9C9"
                }}>
                <p className="text-[18px] text-[#000000] font-bold">Institute Logo</p>
                {InstituteData.partnerData.logo ? (
                <a
                href={InstituteData.partnerData.logo.previewURL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#625BA8] underline text-[18px]"
                >
                {InstituteData.partnerData.logo.file.name}
                </a>
                ) : null}
                </div>

        {/* Institute Banner */}
        <div className="w-full flex justify-between ">
        <p className="text-[18px] text-[#000000] font-bold">Institute Banner</p>
        {InstituteData.partnerData.banner ? (
        <a
        href={InstituteData.partnerData.banner.previewURL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#625BA8] underline text-[18px]"
        >
        {InstituteData.partnerData.banner.file.name}
        </a>
        ) : null}
        </div>

        {/* Institute Icon */}
        <div className="w-full flex justify-between  py-[10px] bg-[#F8F8F8]"
        style={{
        borderTop: "1px dashed #C9C9C9",
        borderBottom: "1px dashed #C9C9C9"
        }}>
        <p className="text-[18px] text-[#000000] font-bold">Institute Icon</p>
        {InstituteData.partnerData.icon ? (
        <a
        href={InstituteData.partnerData.icon.previewURL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#625BA8] underline text-[18px]"
        >
        {InstituteData.partnerData.icon.file.name}
        </a>
        ) : null}
        </div>

            {/* <div className="w-full flex justify-between"
            style={{
                        borderBottom:"1px dashed #C9C9C9"
                }}>
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.partnerData.businessRegistration ? (
                        <img src={InstituteData.partnerData.businessRegistration.previewURL} alt="businessRegistration Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.partnerData.transportationRegistration ? (
                        <img src={InstituteData.partnerData.transportationRegistration.previewURL} alt="transportationRegistration Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
            </div>

            <div className="w-full flex justify-between">
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.partnerData.logo ? (
                        <img src={InstituteData.partnerData.logo.previewURL} alt="logo Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.partnerData.banner ? (
                        <img src={InstituteData.partnerData.banner.previewURL} alt="banner Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
            </div> */}

            <div className="w-full flex flex-col justify-center items-center gap-[15px] mt-[20px] pb-[50px] lg:pb-[50px]">
                <button
                    className={`w-[90%] cursor-pointer rounded-[8px] border-none bg-primary  py-2
                            text-[16px] text-white  xl:py-2 
                                xl:text-[18px]     2xl:text-base`}
                    onClick={handleSubmit}
                //     onClick={()=>setOpenSignupScreen("OwnerDataReview")}
                >
                    Submit
                </button>
                {/* <p className="text-[18px] text-[#625BA8] cursor-pointer" onClick={()=>setOpenSignupScreen("PartnerRegisteration")}>Edit</p> */}
            </div>
        </div>
    </div>
)
}

export default InstituteDataReview;